import { render, staticRenderFns } from "./SpeedChange.vue?vue&type=template&id=356fe997&scoped=true&"
import script from "./SpeedChange.vue?vue&type=script&lang=js&"
export * from "./SpeedChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356fe997",
  null
  
)

export default component.exports